import { render } from "./AchivedBadge.vue?vue&type=template&id=5976bd0e"
import script from "./AchivedBadge.vue?vue&type=script&lang=js"
export * from "./AchivedBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__